import { render } from "./TaskList.vue?vue&type=template&id=bb63b4a8&scoped=true&ts=true"
import script from "./taskListHelper.ts?vue&type=script&lang=ts"
export * from "./taskListHelper.ts?vue&type=script&lang=ts"

import "./TaskList.vue?vue&type=style&index=0&id=bb63b4a8&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb63b4a8"]])

export default __exports__